export default {
    SEARCH_PLACEHOLDER: "Поиск...",
    TASK: "Задача",
    SOURCE: "Источник",
    COMPLETED: "Готово",
    ERRORS: "Ошибки",
    TOTAL_STARTS: "Запуски",
    CANCELED: "Остановлено"
};
